import { FC, HTMLAttributes, useState } from 'react';
import clx from 'classnames';
import st from './Spoiler.module.scss';

interface ISpoilerProps extends HTMLAttributes<HTMLDivElement> {
	/** Состояние спойлера по умолчанию */
	defaultOpen?: boolean;
	/** Функция будет вызвана при изменении состояние спойлера */
	onChangeState?: (isOpen: boolean) => void;
}

/** Компонента предоставляющая интерфейс спойлера, прячущего основной контент под ссылкой */
const Spoiler: FC<ISpoilerProps> = (props) => {
	const {
		title = 'Открыть',
		defaultOpen = false,
		onChangeState,
		children,
		className,
		...otherProps
	} = props;
	// Состояние открыт/закрыт
	const [expand, setExpand] = useState<boolean>(defaultOpen);

	/** Функция вызывается при изменении состояния спойлера */
	const onChangeExpand = () => {
		const newState = !expand;
		if (onChangeState) {
			onChangeState(newState);
		}
		setExpand(newState);
	};

	return (
		<div
			className={clx(st.spoilerBlock, className, {
				[st.expanded]: expand,
			})}
			{...otherProps}
		>
			<p className={clx('body', st.spoilerBtn)} onClick={onChangeExpand}>
				<svg width="18" height="18" viewBox="0 0 18 18" fill="inherit">
					<path
						d="M11.8688 11.25L9 8.38125L6.13125 11.25L5.25 10.3625L9 6.6125L12.75 10.3625L11.8688 11.25Z"
						fill="inherit"
					/>
				</svg>
				{title}
			</p>
			<div className={st.spoilerContent}>{children}</div>
		</div>
	);
};

export default Spoiler;
